import { IApplicationState } from '../../../types/types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { root } from '../../../store/constants';
import { EAuthUserPlatformType } from '../../../types/rest/IRestAuthUser';

const DATE = 1744574400;

export const getMS14AprSessionRecordingNeeded = (
    state: IApplicationState
) => {
    if (!root.App.controller.mainView.getMS14AprSessionRecording()) {
        return false;
    }
    const { createDateTimeStamp, platformType } = getAuthUser(state);
    return createDateTimeStamp > DATE && platformType === EAuthUserPlatformType.MICROSOFT;
};
